var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.elementList),function(element,index){return _c('tr',{key:index},[_c('td',{staticClass:"font-bold px-4 w-1/2"},[_vm._v(_vm._s(element.name))]),_c('td',{staticClass:"w-16"},[_vm._v(_vm._s(element.details))]),_c('td',{staticClass:"w-16"},[_vm._v(_vm._s(element.quantity)+" "+_vm._s(element.unit))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }